module.exports = __webpack_public_path__ + "img/tertiary_9x3_z16.f09eb211.svg";